import { createContext, useContext } from 'react';
import { FileExplorerContextValue } from './types';

export const FileExplorerContext = createContext<FileExplorerContextValue | null>(null);

export function useFileExplorerContext(): FileExplorerContextValue {
  const ctx = useContext(FileExplorerContext);
  if (!ctx) {
    throw new Error('useFileExplorerContext must be used within a FileExplorerProvider');
  }
  return ctx;
}
